import * as React from 'react';
import VoxelText from '../Text/VoxelText';

export interface VoxelDialogSubtitleProps {
  textColor?: string;
}

const VoxelDialogSubtitle: React.FC<VoxelDialogSubtitleProps> = ({ children, textColor }) => {
  return (
    <VoxelText className="px-8" variant={'bread-normal'} paddingBot colorClassName={textColor}>
      {children}
    </VoxelText>
  );
};

export default VoxelDialogSubtitle;
